import React from 'react';

export const LtcContext = React.createContext({});
